export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MainPage.vue?vue&type=template&id=4d7d4066&"


//////////////////
// WEBPACK FOOTER
// ./src/views/MainPage.vue?vue&type=template&id=4d7d4066&
// module id = 881
// module chunks = 0